import { trans } from '../../functions';
import { collapseFilters } from './index/helpers';

export default {
    props: [
        'initialQuery',
        'initialCategoryName',
        'initialCategoryBanner',
        'initialCategorySlug',
        'initialTagName',
        'initialTagSlug',
        'initialAttribute',
        'initialSort',
        'initialPerPage',
        'initialPage',
        'initialViewMode',
    ],

    data() {
        return {
            fetchingBlogs: false,
            blogs: { data: [] },
            attributeFilters: [],
            categoryName: this.initialCategoryName,
            categoryBanner: this.initialCategoryBanner,
            viewMode: this.initialViewMode,
            queryParams: {
                query: this.initialQuery,
                category: this.initialCategorySlug,
                tag: this.initialTagSlug,
                attribute: this.initialAttribute,
                sort: this.initialSort,
                perPage: this.initialPerPage,
                page: this.initialPage,
            },
        };
    },

    computed: {
        emptyBlogs() {
            return this.blogs.data.length === 0;
        },

        totalPage() {
            return Math.ceil(this.blogs.total / this.queryParams.perPage);
        },

        showingResults() {
            if (this.emptyBlogs) {
                return;
            }

            return trans('nya::blogs.showing_results', {
                from: this.blogs.from,
                to: this.blogs.to,
                total: this.blogs.total,
            });
        },
    },

    mounted() {
        this.addEventListeners();
        this.fetchBlogs();
    },

    methods: {
        addEventListeners() {
            $(this.$refs.sortSelect).on('change', (e) => {
                this.queryParams.sort = e.currentTarget.value;

                this.fetchBlogs();
            });

            $(this.$refs.perPageSelect).on('change', (e) => {
                this.queryParams.perPage = e.currentTarget.value;

                this.fetchBlogs();
            });
        },

        changeCategory(category) {
            this.categoryName = category.name;
            this.categoryBanner = category.banner.path;
            this.queryParams.query = null;
            this.queryParams.category = category.slug;
            this.queryParams.attribute = {};
            this.queryParams.page = 1;

            this.fetchBlogs();
        },

        changePage(page) {
            this.queryParams.page = page;

            this.fetchBlogs();
        },

        fetchBlogs(options = { updateAttributeFilters: true }) {
            this.fetchingBlogs = true;

            $.ajax({
                url: route('blogs.index', this.queryParams),
            }).then((response) => {
                this.blogs = response.blogs;

                if (options.updateAttributeFilters) {
                    this.attributeFilters = response.attributes;
                }

                this.$nextTick(() => {
                    collapseFilters();
                });
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.fetchingBlogs = false;
            });
        },
    },
};
